// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".warning-icon[data-v-4c8ec200] {\n  margin-top: -2px;\n  margin-right: 3px;\n}\n.warning-label[data-v-4c8ec200] {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  max-width: 50%;\n}\n.warning-color[data-v-4c8ec200] {\n  color: #ff811c;\n}\n", ""]);
// Exports
module.exports = exports;
